import React, { useEffect, useState } from "react";
import { SoulSingles, userProfile } from "../images";
import { useSocket } from "../context/SocketContext";
import { useDispatch, useSelector } from "react-redux";
import { getRooms, updateRoom } from "../store/roomSlice";
import RoomCard from "../components/RoomCard";
import { decryptData } from "../helpers/cryptoSocketData";
import { useNavigate } from "react-router-dom";

function VideoChatLobby() {
  const socket = useSocket();
  const { rooms, error } = useSelector((state) => state.room);
  const username = JSON.parse(sessionStorage.getItem("username"))
  const userProfileImg = JSON.parse(sessionStorage.getItem("profileImg"))
  const token = JSON.parse(sessionStorage.getItem("token"))
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  sessionStorage.removeItem("currUrlPath");
  sessionStorage.removeItem("peerId");
  sessionStorage.removeItem("isVidEnable");
  sessionStorage.removeItem("isMicEnable");
  useEffect(() => {
    dispatch(getRooms());
  }, [dispatch]);

  useEffect(() => {
    if (socket) {
      // Listen for room updates from WebSocket
      socket.on("user-count-updated", (dataToEmit) => {
        const decryptDataToEmit = decryptData(dataToEmit);
        dispatch(updateRoom(decryptDataToEmit)); // Dispatch action to update Redux state
      });
      // Cleanup on component unmount
      return () => {
        socket.off("user-count-updated");
      };
    }
  }, [dispatch, socket]);

  const handleLobbyNavigate = () => {
    window.location.href = "/lobby";
  }

  const handleNavigate = () => {
    window.open(process.env.REACT_APP_WORLDSINGLES_APP_URL, "_self")
  }
  const handleLogout = () => {
    sessionStorage.clear();
    window.open(process.env.REACT_APP_WORLDSINGLES_APP_URL, "_self");
    setShowDropdown(false);
  };

  if (error) {
    return (
      <div className="main-box">
        <div className="error">
          <h5>{error.message.slice(6)}</h5>
          <button className="leave-btn" onClick={handleLobbyNavigate}>Return to lobby</button>
        </div>
      </div>
    );
  }

  return (
    <div className="main-box">
      {!token ? (
        <div className="waiting-loader">
          <h2>You have been logged out.</h2>
          <button className="leave-btn" onClick={handleNavigate}>Return to Dashboard</button>
        </div>
      ) : (
        <div className="vc-main-box">
          <header className="vc-header">
            <div className="vc-container container-header">
              <div className="vc-logo-box">
                <img src={SoulSingles} alt={process.env.REACT_APP_WORLDSINGLES_APP_NAME} />
                <div className="username-section" onClick={() => setShowDropdown(!showDropdown)}
                  onMouseEnter={() => setShowDropdown(true)}
                  onMouseLeave={() => setShowDropdown(false)}>
                  <img src={userProfileImg ? userProfileImg : userProfile} alt="" draggable={false} />
                  <p>{username}</p>
                  {showDropdown && <div className="dropdown-menu">
                    <button onClick={handleLogout}>Logout</button>
                  </div>}
                </div>
              </div>
            </div>
          </header>
          <div className="vc-contain-main-box">
            <div className="container scroll">
              <div className="vc-title">
                <h1>Welcome to the {process.env.REACT_APP_WORLDSINGLES_APP_NAME} Video Chat Lobby!</h1>
                <p>
                  We're thrilled to have you here. This is your space to meet and
                  connect with others in real-time. Click on a table to enter the
                  conversation, share ideas, and collaborate with fellow
                  participants.
                </p>
              </div>
              <div className="vc-contain-wrapper">
                {rooms?.map((room) => {
                  return <RoomCard key={room.id} room={room} />
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoChatLobby;
